import { Component } from '@angular/core';

import { ApiWalletService } from "@modules/private/wallet/data/services/api/api-wallet.service";
import { WALLET_COLUMNS } from "@modules/private/wallet/data/constants/wallet.constants";
import { UserRole } from "@data/enums/user-role.enum";
import { MessageService } from "primeng/api";
import { Router } from '@angular/router';

@Component({
  selector: 'app-wallet-list',
  templateUrl: './wallet-list.component.html',
  styleUrls: ['./wallet-list.component.scss'],
  providers: [MessageService]
})
export class WalletListComponent {
  columns = WALLET_COLUMNS;
  wallets: any[] = [];
  walletId!: string | null;
  walletAdmin: any = {};
  loading = true
  isAdmin = false
  
  constructor(
    public apiWalletService: ApiWalletService,
    private router: Router
  ) {
    if (this.apiWalletService.role === UserRole.ADMIN) {
      this.isAdmin = true
      this.apiWalletService.getAdminWalletAmounts().subscribe(wallet => {
        this.walletAdmin = wallet;
        this.loading = false;
      });
    }

    this.apiWalletService.getWalletAmounts().subscribe(wallets => {
      this.wallets = wallets;
      this.loading = false;
    });
  }

  goToWalletDetails(wallet?: any) {
    this.apiWalletService.wallet = wallet
    this.router.navigate([`/wallet/${wallet.wallet._id}`]);
  }

  goToAdminDetails() {
    this.router.navigate([`/wallet/admin-details`]);
  }

  /** Lentes de cartera (F36): la renta siempre cuenta; el resto se enciende y apaga. */
  lens = { accessories: true, residual: true, mora: true };

  //* La combinación se arma sumando componentes en el cliente: no hace falta una consulta por lente.
  carteraFiltrada(c: { rent: number, accessories: number, mora: number, residual: number } | undefined): number {
    if (!c) return 0;
    return c.rent + (this.lens.accessories ? c.accessories : 0) + (this.lens.residual ? c.residual : 0) + (this.lens.mora ? c.mora : 0);
  }

}